import React, { useState } from 'react';
import { Tooltip, Input, DatePicker } from 'antd';
import {
  AdvSearchIcon,
  MenuDrawer,
  ContentSection,
  SearchTitle,
  FilterTitle,
} from '../MailRoom/styles';
import moment from 'moment';
import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { MAILROOM_BATCH_FILTER } from './translationValues';

const NAMESPACES = ['MAILROOM_BATCH_FILTER'] 

const { Search } = Input;
const { RangePicker } = DatePicker;

const AdvanceFilter = props => {
  const {
    visibility,
    title,
    setSearchValue,
    startAndEndDate,
    setStartAndEndDate,
    setDefaultWeek,
    showDrawer,
    setShowDrawer,
    deleteDocuments,
    createBatch,
    setDateFilterApplied,
    t
  } = props;

  const [drawAnimate, setDrawAnimate] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [selectedDate, setSelectedDate] = useState({});

  useEffect(() => {
    if (createBatch || deleteDocuments) {
      setSelectedDate({})
    }
  }, [createBatch, deleteDocuments])

  const hideDraw = () => {
    setShowDrawer(false);
    setDrawAnimate(true);
    setTimeout(() => {
      setDrawAnimate(false);
    }, 1800);
  };

  const showDraw = () => {
    setShowDrawer(true);
    setTimeout(() => {
    }, 1000);
  };

  const disabledDate = current => {
    return current > moment() || current < moment().subtract(30, 'day');
  };

  const dateValue = d => {
    let y = d.getFullYear();
    let m = ('0' + (d.getMonth() + 1)).slice(-2);
    let dt = ('0' + d.getDate()).slice(-2);
    let h = ('0' + d.getHours()).slice(-2);
    let mt = ('0' + d.getMinutes()).slice(-2);
    let s = ('0' + d.getSeconds()).slice(-2);
    return y + '-' + m + '-' + dt + ' ' + h + ':' + mt + ':' + s;
  };

  return (
    <>
      <MenuDrawer
        SearchDrawer={true}
        className={showDrawer ? 'drawVisible' : drawAnimate ? 'drawAnimate' : 'drawInVisible'}
      >
        <div className={!showDrawer ? 'switch' : 'switch_searchBar'} />
        <div className="searchDrawer">
          {showDrawer && (
            <ContentSection>
              <div style={{ position: 'relative', width: '100%' }}>
                <SearchTitle>{title}</SearchTitle>
                <Tooltip placement="bottom" title={t(MAILROOM_BATCH_FILTER.CLOSE_ADVANCED_SEARCH_TOOLTIP.key,MAILROOM_BATCH_FILTER.CLOSE_ADVANCED_SEARCH_TOOLTIP.value)}>
                  <AdvSearchIcon
                    type={'close'}
                    closeIcon={true}
                    showSearchIcon={1}
                    onClick={hideDraw}
                    height={'3em'}
                  />
                </Tooltip>
              </div>
              <FilterTitle>{t(MAILROOM_BATCH_FILTER.APPLIED_FILTER_SEARCH_LABEL.key,MAILROOM_BATCH_FILTER.APPLIED_FILTER_SEARCH_LABEL.value)}</FilterTitle>
              <Search
                placeholder={t(MAILROOM_BATCH_FILTER.SEARCH_PLACEHOLDER.key,MAILROOM_BATCH_FILTER.SEARCH_PLACEHOLDER.value)}
                onPressEnter={() => setSearchValue(searchText)}
                onSearch={() => setSearchValue(searchText)}
                allowClear={true}
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value);
                  e.target.value.length === 0 && setSearchValue(null);
                }}
              />
              <FilterTitle isDate={1}>{t(MAILROOM_BATCH_FILTER.APPLIED_FILTER_DATE_RANGE_LABEL.key,MAILROOM_BATCH_FILTER.APPLIED_FILTER_DATE_RANGE_LABEL.value)}</FilterTitle>
              <RangePicker
                disabledDate={disabledDate}
                format="YYYY-MM-DD HH:mm:ss"
                placeholder={[t(MAILROOM_BATCH_FILTER.APPLIED_FILTER_DATE_RANGE_LABEL.key,MAILROOM_BATCH_FILTER.APPLIED_FILTER_DATE_RANGE_LABEL.value), t(MAILROOM_BATCH_FILTER.RANGEPICKER_TO_PLACEHOLDER.key,MAILROOM_BATCH_FILTER.RANGEPICKER_TO_PLACEHOLDER.value)]}
                onChange={e => {
                  let dates = {
                    startDate: e[0] && dateValue(e[0]._d),
                    endDate: e[1] && dateValue(e[1]._d),
                  };
                  if (e.length === 0) {
                    setDefaultWeek();
                    setSelectedDate({});
                    setDateFilterApplied(false);
                  } else {
                    setSelectedDate(dates);
                    setDateFilterApplied(true);
                  }
                }}
                value={
                  selectedDate.startDate && selectedDate.endDate
                    ? [moment(selectedDate.startDate), moment(selectedDate.endDate)]
                    : [moment(startAndEndDate.startDate), moment(startAndEndDate.endDate)]
                }
                allowClear
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss').subtract(7, 'day'), moment()],
                }}
                defaultValue={[moment().subtract(7, 'day'), moment()]}
                onOk={() => setStartAndEndDate(selectedDate)}
              />
            </ContentSection>
          )}
        </div>
      </MenuDrawer>

      {visibility && (
        <Tooltip placement="left" title={t(MAILROOM_BATCH_FILTER.ADVANCED_SEARCH_TOOLTIP.key,MAILROOM_BATCH_FILTER.ADVANCED_SEARCH_TOOLTIP.value)}>
          <AdvSearchIcon type={'search'} onClick={() => showDraw()} />
        </Tooltip>
      )}
    </>
  );
};

export default withTranslation(NAMESPACES)(AdvanceFilter);
